import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { Button } from './ui/Button';
import SafeIcon from '../src/common/SafeIcon';

const { FiCheck, FiVideo, FiUsers, FiBookOpen, FiArrowRight } = FiIcons;

export const Pricing: React.FC = () => {
  return (
    <section className="py-24 bg-slate-900 text-white relative overflow-hidden" id="enroll">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-500 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">Start Your Learning Journey</h2>
            <p className="text-slate-300 text-lg mb-8">Gain the confidence to discuss digital assets professionally. Join financial advisors who are bridging the knowledge gap today.</p>
            <div className="space-y-4">
              <div className="flex items-center gap-4 p-3 rounded-lg bg-slate-800/50 border border-slate-700">
                <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-brand-400" />
                </div>
                <div>
                  <span className="block font-semibold">Self-Paced Mini-Course</span>
                  <span className="text-sm text-slate-400">Complete in under an hour</span>
                </div>
              </div>
              <div className="flex items-center gap-4 p-3 rounded-lg bg-slate-800/50 border border-slate-700">
                <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-brand-400" />
                </div>
                <div>
                  <span className="block font-semibold">Lifetime Access</span>
                  <span className="text-sm text-slate-400">Revisit materials anytime</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white text-slate-900 rounded-2xl p-8 shadow-xl max-w-md w-full mx-auto relative">
            <div className="absolute top-0 right-0 bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">INSTANT ACCESS</div>
            <h3 className="text-xl font-bold text-slate-500 mb-2">Mini-Course Access</h3>
            <div className="flex items-baseline gap-1 mb-6">
              <span className="text-4xl font-bold text-slate-900">$200</span>
              <span className="text-slate-500">/One-time</span>
            </div>
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3 text-slate-700">
                <SafeIcon icon={FiVideo} className="w-5 h-5 text-brand-600" />
                <span>6 Core Modules + Bonus</span>
              </div>
              <div className="flex items-center gap-3 text-slate-700">
                <SafeIcon icon={FiBookOpen} className="w-5 h-5 text-brand-600" />
                <span>Certificate of Completion</span>
              </div>
            </div>
            <Button variant="primary" fullWidth size="lg" className="group">
              <span>Start The Mini-Course</span>
              <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <p className="text-xs text-center text-slate-400 mt-4">Secure checkout • 30-day guarantee</p>
          </div>
        </div>
      </div>
    </section>
  );
};